const messages = {
  title: "Mijn Bridgestone <span class='text-danger'>Plus</span>",
  desc: "Hier kunt u uw gegevens aanvullen of aanpassen, uw mailbox en uw bandenbestellingen met puntenoverzicht bekijken.",
  descStaff:
    "Hier kunt u uw gegevens aanvullen of aanpassen, uw mailbox en uw bandenbestellingen met puntenoverzicht bekijken.",
  buttons: {
    showProfile: "Profiel weergeven",
    userProfile: "Naar uw gegevens",
    mailbox: "Naar uw inbox ",
    addNewEmail: "Nieuwe e-mail toevoegen",
  },
  categories: {
    baseData: {
      title: "Profiel & gegevens",
      desc: "Voer hier uw contact- en bedrijfsgegevens in.",
    },
    favoriteProducts: {
      title: "Favoriete producten",
      desc: "Hier vindt u de producten die u heeft opgeslagen.",
    },
    mailbox: {
      desc: "In uw persoonlijke mailbox vindt u belangrijk nieuws en updates.",
    },
    bankstatement: {
      title: "Bandenbestellingen & puntenoverzicht",
      desc: "Hier kunt u uw huidige bandenbestellingen en uw puntenoverzicht bekijken.",
    },
    basedata: {
      title: "Profiel & gegevens",
      desc: "Voer hier uw contact- en bedrijfsgegevens in.",
    },
    pobox: {
      title: "Inbox",
      desc: "In uw persoonlijke mailbox vindt u belangrijk nieuws en updates.",
    },
  },
  profile: {
    general: "Persoonlijke & bedrijfsgegevens",
    title: "Mijn Profiel",
    description: "Hier kunt u uw gegevens aanvullen of aanpassen.",
    block_description:
      "Welkom in uw persoonlijke ruimte. Hier kunt u uw gegevens bekijken",
    personalData: "Persoonsgegevens",
    password: "Wachtwoord",
    password1: "Wachtwoord (vrij te kiezen)*",
    password2: "Wachtwoord (herhalen)*",
    formOfAddress: "Aanhef",
    choose: "Kies",
    mr: "Dhr.",
    mrs: "Mevr.",
    diverse: "Verscheidene",
    firstname: "Voornaam",
    surname: "Achternaam",
    position: "Functie in het Bedrijf",
    operatingData: "Bedrijfsgegevens",
    company: "Naam bedrijf",
    legalForm: "Rechtsvorm",
    name: "Naam",
    streetHouseNr: "Straat & huisnummer",
    street: "Straat",
    postcode: "Postcode",
    location: "Plaats",
    country: "Land",
    de: "Duitsland",
    at: "Oostenrijk",
    ch: "Zwitserland",
    nl: "Nederland",
    it: "Italië",
    language: "Taal",
    french: "Frans",
    italian: "Italiaans",
    german: "Duitsland",
    nederland: "Nederland",
    phone: "Telefoon",
    website: "Website",
    operatingIndicators: "Belangrijkste operationele cijfers",
    tireSale: "Bandenverkoop per jaar alle bandenmerken",
    tireSaleLabel: "Verkoop banden in aantallen",
    inches: "≥ 18 inches (in %)",
    inchesLabel: "Waarvan 18 inch en groter in",
    segmentSale:
      "BANDENVERKOOP PER SEGMENT (aandeel Premium / Midden / Budget in %)",
    premBudget: "Premium in",
    midBudget: "Midden in",
    budBudget: "Budget in",
    distribution:
      "BANDENVERKOOP PER SEIZOEN (verdeling zomer / winter / all season in %)",
    summerIn: "De zomer tegemoet",
    winterIn: "De winter is er",
    allSeasonIn: "Het hele seizoen",
    tyreSizes: "Aantal opslagen per seizoen (bandensets)",
    diffDeliveryAddres: "Afleveradres toevoegen",
    yourEmailAddress: "Jouw e-mail adres*",
    clientNr: "Uw Klantnummers",
    clientNrSingular: "Klantnummer",
    clientNrContent:
      "<span class='text-danger fw-bold'>BELANGRIJK - LEZEN A.U.B:</span><br /><br /> Voor de toewijzing van uw bandenbestellingen bij onze distributeurs is het <b>essentieel dat uw klantnummers bij deze distributeurs gekoppeld zijn.</b> Hiernaast vindt u uw reeds gekoppelde klantnummers.<br/><br/>Bestelt u ook banden op andere klantnummers? Deze voegen wij graag voor u toe, neem hiervoor contact op met uw Bridgestone vertegenwoordiger. Kijk op de service & contact pagina voor de contactgegevens.",
    supplySource: "Distributeur",
    email: "E-mail adres",
    staffEmail: "E-mailadres deelnemer",
    registered: "Geregistreerd",
    registeredAt: "Geregistreerd op",
    lastLogIn: "Laatste aanmelding",
    details: "Details",
    inDetail: "{name} in detail",
    customerFile: "Klantenfiche",
    customerHistory: "Klantgeschiedenis",
    currentYear: "Huidig jaar",
    bsClientNr: "Uw Bridgestone-klantnummer",
    bftClientNr: "Uw Best4Tires-klantnummer",
    acceptTerms: "Ik accepteer de algemene voorwaarden.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>BELANGRIJK - LEZEN A.U.B:</span><br />Het kan tot 5 werkdagen duren om de klantnummer(s) te activeren en aan uw profiel te koppelen.",
    selectWholeSaler: "Kies hier de distributeur",
    cooperation: "LID / SAMENWERKING",
    error100: "De som van de waarden moet 100% zijn.",
    errorRange: "De waarde moet tussen 0 en 100 liggen",
    btw_number_label: "Bijvoorbeeld: NL123456789B01",
    btw_number: "BTW-nummer",
    mobile: "(MOBIEL) TELEFOONNUMMER",
    mobile_label: "Uw (mobiel) telefoonnummer",
    iban_number: "IBAN-nummer VAN UW BEDRIJF",
    iban_number_label: "Bijvoorbeeld: NL91ABNA0417164300",
    iban_check_reminder:
      "Controleer uw IBAN voor 27 februari om uw bonus over 2025 te ontvangen.",
    iban_min_16_digits: "Het IBAN-nummer moet minimaal 16 tekens bevatten.",
    yourCsNr: "Uw klantnummers",
    yourLastName: "Uw achternaam",
    positionLabel: "Functie binnen het bedrijf",
    yourFirstName: "Uw voornaam",
    companyLabel: "Bedrijf",
    numberOfSetsOfSeasonalTiresBudget: "Opslag per jaar",
    contactInfo: "Als u vragen heeft, kunt u contact opnemen met:",
    addAnotherCsNumber: "Voeg een ander Bridgestone-klantnummer toe",
    activityAndProfile: "BEDRIJFSACTIVITEIT EN PROFIEL",
    financialEmail: "Financial emails",
    indirectCustomNumberHelpMessage:
      "No pudimos detectar la configuración de tu número de cliente. Por favor, revisa tu perfil y confirma si eres un cliente directo o indirecto para continuar.",
    completeProfile: "Vul uw persoonlijke profiel in en verdien",
    completeProfileBold: "25 extra punten.",
    salesRepresentative: "Sales Representative",
    tireSaleDetail: "Bandenverkoop per jaar",
  },
  countries: {
    al: "Albanië",
    ad: "Andorra",
    at: "Oostenrijk",
    be: "België",
    by: "Wit-Rusland",
    ba: "Bosnië en Herzegovina",
    bg: "Bulgarije",
    hr: "Kroatië",
    cy: "Cyprus",
    cz: "Tsjechië",
    dk: "Denemarken",
    ee: "Estland",
    fi: "Finland",
    fr: "Frankrijk",
    ge: "Georgië",
    gr: "Griekenland",
    es: "Spanje",
    nl: "Nederland",
    ie: "Ierland",
    is: "IJsland",
    kz: "Kazachstan",
    xk: "Kosovo",
    li: "Liechtenstein",
    lt: "Litouwen",
    lu: "Luxemburg",
    lv: "Letland",
    mk: "Noord-Macedonië",
    mt: "Malta",
    md: "Moldavië",
    mc: "Monaco",
    de: "Duitsland",
    no: "Noorwegen",
    pl: "Polen",
    pt: "Portugal",
    ru: "Rusland",
    ro: "Roemenië",
    sm: "San Marino",
    rs: "Servië",
    sk: "Slowakije",
    si: "Slovenië",
    se: "Zweden",
    ch: "Zwitserland",
    tr: "Turkije",
    ua: "Oekraïne",
    hu: "Hongarije",
    gb: "Verenigd Koninkrijk",
    it: "Italië",
    va: "Vaticaanstad",
  },
  addCsNumber: {
    title: "Notice",
    body: "Weet u zeker dat u dit klantnummer wilt opslaan? De actieblokken bewerken gegevens totdat de beheerder deze goedkeurt.",
  },
  extraEmailSection: {
    description:
      "Extra emailadressen worden uitsluitend gebruikt voor het toesturen van BS+ marketinginformatie en/of financiele informatie en dienen in <b>geen geval voor het inloggen en of beheer</b> van het Bridgestone PLUS account.",
    optionOne: "Voor financiële info (o.a. bonusspecificatie)",
    optionTwo:
      "Voor Bridgestone Plus marketingcommunicatie (o.a. acties/nieuwsbrieven)",
    addNewEmail: "Nieuw e-mailadres toevoegen",
  },
};

export default {
  messages,
};
